import { render, staticRenderFns } from "./CRMHeader.vue?vue&type=template&id=1cfb6703&scoped=true&"
import script from "./CRMHeader.vue?vue&type=script&lang=js&"
export * from "./CRMHeader.vue?vue&type=script&lang=js&"
import style0 from "./CRMHeader.vue?vue&type=style&index=0&id=1cfb6703&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfb6703",
  null
  
)

export default component.exports